import { AfterViewInit, Component, OnInit } from '@angular/core';
import { DateControl } from '../../../models/controls/date-control';
import { BaseControlComponent } from '../base-control/base-control.component';
import { OrderService } from '../../../services/order/order.service';
import {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import * as moment from 'moment';
import { Moment } from 'moment';
import { DynamicFormService } from '../../../services/dynamic-form/dynamic-form.service';

@Component({
  selector: 'app-date-control',
  templateUrl: './date-control.component.html',
  styleUrls: ['./date-control.component.scss'],
})
export class DateControlComponent
  extends BaseControlComponent<DateControl>
  implements OnInit, AfterViewInit {
  private readonly patternValidator = Validators.pattern(
    /^[0-9]{2}\.[0-9]{2}\.[0-9]{4}$/
  );

  constructor(
    orderService: OrderService,
    dynamicFormService: DynamicFormService
  ) {
    super(orderService, dynamicFormService);
  }

  ngAfterViewInit(): void {
    this.setValidators();
    this.ngModel?.control.setValidators(this.validators);
    super.ngAfterViewInit();
  }

  protected setValidators(): void {
    super.setValidators();
    this.validators.push((control: AbstractControl) =>
      this.getInvalidDateError(control)
    );
  }

  protected getInvalidDateError(
    control: AbstractControl
  ): ValidationErrors | null {
    if (!this.control.required) {
      return null;
    }
    let error = this.patternValidator(control);
    if (error === null && !this.getDate(control.value).isValid()) {
      error = { isValidDate: false };
    }
    return error;
  }

  protected getDate(value: string): Moment {
    return moment(value, 'DD.MM.YYYY', true);
  }
  protected onControlChange(): void {
    this.ngModel?.reset('');
    super.onControlChange();
  }
}
